/**
 * Shim for next/dynamic — uses React.lazy in Vite environments.
 */
import { lazy } from 'react'

export default function dynamic<T extends React.ComponentType<Record<string, unknown>>>(
  loader: () => Promise<{ default: T }>
) {
  return lazy(loader)
}
